(function () {
  const STORAGE_KEY = 'aurelle_recently_viewed';
  const MAX_ITEMS = 8;

  function money(value) {
    return value || '';
  }

  function initRecentlyViewed() {
    const dataEl = document.getElementById('AurelleProductData');
    const section = document.getElementById('AurelleRecentlyViewed');
    const grid = document.getElementById('AurelleRecentGrid');

    if (!dataEl || !section || !grid) return;

    let current;
    try {
      current = JSON.parse(dataEl.textContent.trim());
    } catch (e) {
      console.error('My Rare Aura Recently Viewed: bad product JSON', e);
      return;
    }

    if (!current || !current.id) return;

    let stored = [];
    try {
      stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      stored = [];
    }

    stored = stored.filter(item => String(item.id) !== String(current.id));

    const itemsToShow = stored.slice(0, MAX_ITEMS);

    const currentItem = {
      id: current.id,
      title: current.title || '',
      url: current.url || window.location.pathname,
      image: current.featured_image || '',
      price: current.price || ''
    };

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify([currentItem].concat(stored).slice(0, MAX_ITEMS))
    );

    if (!itemsToShow.length) {
      section.style.display = 'none';
      return;
    }

    section.hidden = false;
    section.style.display = 'block';

    grid.innerHTML = itemsToShow.map(item => `
      <a class="aurelle-recent-card" href="${item.url}">
        <div class="aurelle-recent-card__image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <p class="aurelle-recent-card__brand">My Rare Aura</p>
        <h3>${item.title}</h3>
        <span>${money(item.price)}</span>
      </a>
    `).join('');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyViewed);
  } else {
    initRecentlyViewed();
  }
})();